import {
  ButtonLink,
  FontIcons,
  Placements,
  ButtonLooks,
  DropdownLooks,
  StandardDropdownProps
} from '@brandfolder/react';
import { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import { WhitelabelContext } from '@context/whitelabel';

import { HeaderDropdown } from './header-dropdown';

interface HeaderSupportProps extends Partial<StandardDropdownProps> {}

const UnstyledHeaderSupport: FunctionComponent<HeaderSupportProps> = (props) => {
  const { whitelabel } = useContext(WhitelabelContext);

  return (
    <HeaderDropdown
      {...props}
      id="header-support"
      listItems={[
        {
          children: (
            <ButtonLink
              href={whitelabel.helpDocsBase}
              look={ButtonLooks.Default}
              rel="noreferrer"
              startIcon={FontIcons.KnowledgeBase}
              target="_blank"
            >
              Knowledge Base
            </ButtonLink>
          ),
          key: 'knowledge-base'
        }
      ]}
      look={DropdownLooks.Default}
      placement={Placements.BottomEnd}
    >
      Support
    </HeaderDropdown>
  );
};

const StyledHeaderSupport = styled(UnstyledHeaderSupport)`
  margin-left: auto;
`;

export const HeaderSupport: FunctionComponent<HeaderSupportProps> = (props) => {
  return <StyledHeaderSupport {...props} />;
};
